// Hook to cancel the tickets reservation
import { useCancelOrderTickets } from "@multicines/services";
import { useShoppingCartStore } from "@multicines/stores";
import { getShoppingCartProductsByVendor } from "@multicines/utils";
import { TICKETS_VENDOR } from "@multicines/utils";
import { useCallback, useMemo } from "react";

import { useStoresStore } from "stores/stores/stores.store";

const useCancelReservation = () => {
  const shoppingCart = useShoppingCartStore(store => store.shoppingCart);
  const selectedStore = useStoresStore(store => store.selectedStore);
  const { mutateAsync, reset, ...rest } = useCancelOrderTickets(selectedStore);

  const [ticketStore] = selectedStore ?? [];
  const { vendor } = ticketStore ?? {};
  const { id: selectedTicketVendorId } = vendor ?? {};
  const ticketsCount = useMemo(() => {
    const tickets = getShoppingCartProductsByVendor(
      shoppingCart,
      selectedTicketVendorId ?? TICKETS_VENDOR.id
    );
    if (!tickets) return 0;
    return tickets.length;
  }, [selectedTicketVendorId, shoppingCart]);

  const cancelReservation = useCallback(async () => {
    if (!ticketsCount) return;
    await mutateAsync();
    reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mutateAsync, ticketsCount]);

  return useMemo(
    () => ({ cancelReservation, ...rest }),
    [cancelReservation, rest]
  );
};

export default useCancelReservation;
